module.exports = __webpack_public_path__ + "img/quiz_header_m.c1c30e5.jpg";